import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect, useRef, useCallback, useState } from 'react';
import { useRecoilState } from 'recoil';
import { LightBox } from '@/components/LightBox/LightBox';
import { useController } from '@/hooks/useController';
import { imageLoadedState } from '@/state/session';
import styles from './Message.module.scss';
export const Image = ({ name, url }) => {
    const { notifyWebviewOpened, notifyWebviewClosed } = useController();
    const [imageLoaded, setImageLoaded] = useRecoilState(imageLoadedState);
    const [isLinkBroken, setIsLinkBroken] = useState(false);
    const ref = useRef(null);
    const [open, setOpen] = useState(false);
    const onLoad = useCallback(() => {
        setImageLoaded(true);
    }, [setImageLoaded]);
    useEffect(() => {
        if (ref.current && ref.current.complete && !imageLoaded) {
            onLoad();
        }
    }, [imageLoaded, onLoad]);
    useEffect(() => {
        setImageLoaded(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imageLoaded]);
    const handleImageOpen = useCallback(() => {
        notifyWebviewOpened();
        setOpen(true);
    }, [notifyWebviewOpened]);
    const handleImageClose = useCallback(() => {
        notifyWebviewClosed();
        setOpen(false);
    }, [notifyWebviewClosed]);
    return (_jsxs(_Fragment, { children: [_jsx(LightBox, { open: open, onClose: handleImageClose, url: url }), _jsx("button", { className: cn("image-btn" /* TestClassName.ImageButton */, styles.imageContainer), onClick: handleImageOpen, children: _jsx("img", { className: cn(styles.image, {
                        [styles.isLinkBroken]: isLinkBroken,
                    }), src: url, alt: name, ref: ref, onLoad: onLoad, onError: () => setIsLinkBroken(true) }) })] }));
};
